<template>
  <div class="statistic">
    <div class="value">
      $ {{ count }}
    </div>
    <div class="label">
      USD
    </div>
  </div>
</template>

<script>
export default {
  name: 'dollar',
  computed: {
    count() {
      const dollar = this.$store.state.stats.dollar
      return dollar.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>

<style scoped>
.statistic .label {
  margin-top: 0.75rem !important;
  font-size: 2.5rem;
}
</style>



// WEBPACK FOOTER //
// Dollar.vue?5a020b20